"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJustifyFromRelativeDirection = getJustifyFromRelativeDirection;

function getJustifyFromRelativeDirection(relative) {
  switch (relative) {
    case 'right':
      return 'flex-end';

    case 'left':
    default:
      return 'flex-start';
  }
}